import React, {useState} from "react";
import {QuestionInputProps} from "../Question";
import {createUseStyles} from "react-jss";
import {SortQuestionDefinition} from "../../../state/questions";
import {DragDropContext, Draggable, Droppable, DropResult} from "@react-forked/dnd";
import Button from "engage-client/components/Button";

function dragItemBase() {
	return {
		userSelect: "none",
		padding: 8,
		marginBottom: 8
	};
}

const useStyles = createUseStyles({
	buttonContainer: {
		textAlign: "right",
		margin: [8,0]
	},
	dragContainer: {
		padding: 8,
	},
	dragItem: {
		...dragItemBase(),
		background: "lightgray"
	},
	dragItemActive: {
		...dragItemBase(),
		background: "lightgreen"
	}
});

const reorder = (list:number[], startIndex:number, endIndex:number) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

export default function SortInput({question,onSubmit, submitted}: QuestionInputProps) {
	const classes = useStyles();
	const sortQuestion = question as SortQuestionDefinition;
	const [indices, setIndices] = useState<number[]>(sortQuestion.options.map( (_,index) => index ));

	function onDragEnd(result:DropResult) {
		// dropped outside the list
		if (!result.destination) {
			return;
		}

		const items = reorder(
			indices,
			result.source.index,
			result.destination.index
		);

		setIndices(items);
	}


	return <div>
		<DragDropContext onDragEnd={onDragEnd}>
			<Droppable droppableId="droppable">
				{(provided, snapshot) => (
					<div
						{...provided.droppableProps}
						ref={provided.innerRef}
						className={classes.dragContainer}
					>
						{indices.map((item, index) => (
							<Draggable key={item} draggableId={"d"+item} index={index} isDragDisabled={submitted}>
								{(provided, snapshot) => (
									<div
										ref={provided.innerRef}
										{...provided.draggableProps}
										{...provided.dragHandleProps}
										style={provided.draggableProps.style}
										className={snapshot.isDragging ? classes.dragItemActive : classes.dragItem}
									>
										{sortQuestion.options[item]}
									</div>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
		<div className={classes.buttonContainer}>
			<Button color="primary" onClick={() => onSubmit(indices)} disabled={submitted}>Submit</Button>
		</div>
	</div>;
}